import { useEffect, useState } from 'react';
import { appSettingsRepository } from '@/app/settings/app-settings';
import {
  FIELD_AUTO_SYNC_STATUSES,
  FieldAutoSyncController,
  type FieldAutoSyncStatus,
} from '@/features/sync/engine/field-auto-sync';
import { createFieldSyncRunner } from '@/features/sync/engine/field-sync-runner';

export function useFieldAutoSync() {
  const [status, setStatus] = useState<FieldAutoSyncStatus>(FIELD_AUTO_SYNC_STATUSES.idle);

  useEffect(() => {
    const controller = new FieldAutoSyncController({
      createRunner: async () => createFieldSyncRunner(await appSettingsRepository.load()),
      navigatorLike: globalThis.navigator,
      onStatus: setStatus,
      settingsRepository: appSettingsRepository,
      windowLike: globalThis,
    });

    return controller.start();
  }, []);

  return status;
}
